module.exports = __webpack_public_path__ + "img/card_bg_mortgage_small.a20c61f.png";